import { useMutation } from '@tanstack/react-query';
import { PUBLIC_AI_API } from 'utils/globalApiServices';
import PublicRealPlayHelper from 'features/publicRoleplay/publicRealPlay.helper';

const mutationFn = async ({ assignment_uuid, scenario_uuid, body = {} }) => {
  const url = `/public/realplays/assignments/${assignment_uuid}/scenarios/${scenario_uuid}/sessions/`;
  const { data } = await PUBLIC_AI_API.post(url, { ...body });
  return data;
};

const useCreatePublicRealPlaySessionMutation = () => {
  const { setSessionInfoTemp } = PublicRealPlayHelper();
  return useMutation({
    mutationFn,
    onSuccess: (response) => {
      setSessionInfoTemp(response);
    },
    onError: () => {
      setSessionInfoTemp({});
    },
  });
};

export default useCreatePublicRealPlaySessionMutation;
